var search = {};

(function (searchApp) {
	var filterModel = {
		SearchTerm: "",
		ArticlePage: 1,
		EventPage: 1
	};

	var fromPopState = false;
	var blockPopstateEvent = true;
	var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

	if (browserSupportsHistoryApi) {
		// prevent Chrome from calling onpopstate on initial load
		$(window).on('load', function () {
			// The timeout ensures that popstate-events will be unblocked right
			// after the load event occured, but not in the same event-loop cycle.
			setTimeout(function () { blockPopstateEvent = false; }, 0);
		});

		$(window).on('popstate', function () {
			if (blockPopstateEvent && document.readyState === "complete") {
				return;
			}
			fromPopState = true;
			performSearchFromUrl();
		});
	}

	function pushHistory() {
		if (browserSupportsHistoryApi && !fromPopState) {
			var currentPath = window.location.pathname;
			var query = "?";
			var queryArray = [];
			if (filterModel.SearchTerm) {
				queryArray.push("search=" + filterModel.SearchTerm);
			}
			if (filterModel.ArticlePage) {
				queryArray.push("articlepage=" + filterModel.ArticlePage);
			}
			if (filterModel.EventPage) {
				queryArray.push("eventpage=" + filterModel.EventPage);
			}
			query += queryArray.join("&");
			history.pushState(null, null, currentPath + query);
		}
		fromPopState = false;
	}

	function performSearchFromUrl() {
		filterModel.SearchTerm = null;
		filterModel.ArticlePage = 1;
		filterModel.EventPage = 1;
		searchApp.setInputValue();

		if (window.location.search.length > 1) {
			for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
				nKeyId < aCouples.length;
				nKeyId++) {
				aItKey = aCouples[nKeyId].split("=");
				if (aItKey.length <= 1)
					continue;
				var key = decodeURIComponent(aItKey[0]).toLowerCase();
				var val = decodeURIComponent(aItKey[1]);

				if (key === "search") {
					filterModel.SearchTerm = val;
					searchApp.setInputValue();
				} else if (key === "articlepage") {
					filterModel.ArticlePage = val;
				} else if (key === "eventpage") {
					filterModel.EventPage = val;
				}
			}
		}
		searchApp.GetSearchResults();
	}

	searchApp.setInputValue = function () {
		$(".js-search-field").val(filterModel.SearchTerm);
	};

	searchApp.setPageTitle = function () {
		var pageTitle = filterModel.SearchTerm === null || filterModel.SearchTerm === "" ? "Search" : "Search Results";
		$(".js-page-title").text(pageTitle);
	};

	searchApp.GetSearchResults = function () {
		$.ajax({
			url: "/umbraco/surface/SearchSurface/GetSearchResults",
			type: "POST",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-search-results").html(data);
				searchApp.setPageTitle();
				pushHistory();
			}
		});
	};

	searchApp.GetArticleSearchResults = function () {
		$.ajax({
			url: "/umbraco/surface/SearchSurface/GetArticleSearchResults",
			type: "POST",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-search-results-article").html(data);
				pushHistory();
			}
		});
	};

	searchApp.GetEventSearchResults = function () {
		$.ajax({
			url: "/umbraco/surface/SearchSurface/GetEventSearchResults",
			type: "POST",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-search-results-event").html(data);
				pushHistory();
			}
		});
	};

	$(document).ready(function () {
		//Get url params on load
		const urlParams = new URLSearchParams(window.location.search);

		//check if querystring params exist on load/reload
		if (urlParams.get('search')) {
			filterModel.SearchTerm = decodeURI(urlParams.get('search'));
			searchApp.setInputValue();
		}

		if (urlParams.get('articlepage'))
			filterModel.ArticlePage = urlParams.get('articlepage');

		if (urlParams.get('eventpage'))
			filterModel.EventPage = urlParams.get('eventpage');

		
		$("#search-page-form").on('submit', function (e) {
			e.preventDefault();
			filterModel.SearchTerm = $(".js-search-field").val();
			filterModel.ArticlePage = 1;
			filterModel.EventPage = 1;
			searchApp.GetSearchResults();
		});

		//on pagination click event
		$(document).on('click', 'ul.pagination a', function (e) {
			e.preventDefault();
			var type = $(this).closest('ul').data('type');
			if (type === "BlogArticle") {
				filterModel.ArticlePage = $(this).data('page');
				searchApp.GetArticleSearchResults();
				paginationScrollToTop(".js-news-results");
			}
			else if (type === "Event") {
				filterModel.EventPage = $(this).data('page');
				searchApp.GetEventSearchResults();
				paginationScrollToTop(".js-events-results");
			}
		});

		function paginationScrollToTop(classToScrollTo) {
			$([document.documentElement, document.body]).animate({
				scrollTop: $(classToScrollTo).offset().top - $("header").outerHeight()
			}, 200);
		}
	});

})(search);
